<template>
  <!-- Header -->
  <header
      class="header"
      :style="{
      background: isScrolled ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)',
    }"
      :class="{
      'header-trans': logoPath === '/trang-chu',
      'header-sticky fixed-top': logoPath !== '/trang-chu',
      isScrolled,
    }">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg header-nav">
        <div class="navbar-header">
          <a id="mobile_btn" href="javascript:void(0);" @click="toggleSidebar">
            <span class="bar-icon">
              <span :style="{ backgroundColor: !isScrolled && logoPath === '/trang-chu' ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)' }"></span>
              <span :style="{ backgroundColor: !isScrolled && logoPath === '/trang-chu' ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)' }"></span>
              <span :style="{ backgroundColor: !isScrolled && logoPath === '/trang-chu' ? 'rgb(255,255,255)' : 'rgb(186, 42, 51)' }"></span>
            </span>
          </a>
          <router-link to="/trang-chu" class="navbar-brand logo">
            <img
                :src="require(`@/assets/img/${logoImage}`)"
                class="img-fluid"
                alt="Logo"
                style="height: 60px"
            />
          </router-link>
        </div>
        <header-menu></header-menu>
        <ul class="nav header-navbar-rht">
          <li class="nav-item">
            <div :class="logRegisterClass">
              <router-link to="/login"
              ><span><i class="feather-users"></i></span>Đăng
                nhập</router-link
              >
            </div>
          </li>
        </ul>
      </nav>
    </div>
    <div
        class="sidebar-overlay"
        :class="{ opened: isSidebarOpen }"
        @click="closeSidebar"
    ></div>
  </header>
  <!-- /Header -->
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
      isSidebarOpen: false,
      logRegisterClass: "",
    };
  },
  watch: {
    $route(to) {
      this.updateLogRegisterClass(to.path);
    },
  },
  created() {
    this.updateLogRegisterClass(this.$route.path);
  },
  computed: {
    logoPath() {
      return this.$route.path;
    },
    logoImage() {
      if (this.logoPath === "/trang-chu") {
        if (this.isScrolled) {
          return "logo_red.png";
        } else {
          return "logo_white.png";
        }
      } else {
        return "logo_red.png";
      }
    },
  },
  methods: {
    updateLogRegisterClass(path) {
      if (path === "/trang-chu") {
        this.logRegisterClass = "nav-link btn btn-white log-register";
      } else {
        this.logRegisterClass = "nav-link btn btn-primary log-register";
      }
    },
    handleScroll() {
      const scroll = window.scrollY;
      this.isScrolled = scroll > 35;
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
      document.documentElement.classList.toggle("menu-opened");
    },
    closeSidebar() {
      this.isSidebarOpen = false;
      document.documentElement.classList.remove("menu-opened");
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>